import React from 'react';
import { FiUploadCloud, FiLayout, FiCode } from 'react-icons/fi';
import * as styles from './PageBlocks.module.styl';

export default function CTAPanel(props) {
  const get = (obj, prop, fallback) => (obj[prop] ? obj[prop] : fallback);
  const content = props;
  return (
    <div className={styles.bottomCTA}>
      <div className={styles.bottomCTAInner}>
        <h3 className="H1 mx-auto max-w-3xl">
          {get(content, 'title', "Our customers love us. Here's why.")}
        </h3>
        <div className={styles.bottomCTAColumns}>
          <div>
            <FiUploadCloud />
            <h4>{get(content, 'panel_1_title', 'Integrations')}</h4>
            <p>
              {get(
                content,
                'panel_1_description',
                '2000+ In-app and Zapier integrations that  help you automate your workflows.',
              )}
            </p>
          </div>
          <div>
            <FiLayout />
            <h4>{get(content, 'panel_2_title', 'Template Library')}</h4>
            <p>
              {get(
                content,
                'panel_2_description',
                'Over 300 designer templates to choose from.',
              )}
            </p>
          </div>
          <div>
            <FiCode />
            <h4>{get(content, 'panel_3_title', 'Custom Solutions')}</h4>
            <p>
              {get(
                content,
                'panel_3_description',
                'Use custom HTML & CSS for greater flexibility. Use logic and calcuations to take control.',
              )}
            </p>
          </div>
        </div>
        <form className={styles.getStartedForm} action="/register" method="GET">
          <input
            type="email"
            name="email"
            placeholder="Enter your email address"
          />
          <button type="button">Get Started →</button>
        </form>
        <small>
          Start your 7 Day FREE Trial · No CC Required · Cancel anytime
        </small>
      </div>
    </div>
  );
}
